import { curry } from './curry';

function propEqFn(propToFind: string, valueToMatch: any, obj: any) {
  if (!obj) return false;

  return obj[propToFind] === valueToMatch;
}

export const propEq = curry(propEqFn);
